import { useEffect } from "react";
import { blurPanelField } from "../../domain/reveal-selection";
import { useEditorActions } from "../../domain/redux/hooks";
import { resolveEmailBuilderHistoryHotkey } from "../emailBuilderHistoryHotkeys";

export function useEmailBuilderClientShellHistoryHotkeys(mode: "design" | "preview"): void {
  const { undo, redo } = useEditorActions();

  useEffect(() => {
    if (mode !== "design") {
      return;
    }

    function handleKeydown(event: KeyboardEvent) {
      const action = resolveEmailBuilderHistoryHotkey(event);
      if (action === null) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      blurPanelField();
      if (action === "redo") {
        redo();
      } else {
        undo();
      }
    }

    window.document.addEventListener("keydown", handleKeydown, true);
    return () => window.document.removeEventListener("keydown", handleKeydown, true);
  }, [mode, redo, undo]);
}
